import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  showMore: { id: 'CommonMessages.ShowMore', defaultMessage: 'Show more' },
  back: { id: 'CommonMessages.Back', defaultMessage: 'Back' },
  home: { id: 'CommonMessages.Home', defaultMessage: 'Home' },
  loading: { id: 'CommonMessages.Loading', defaultMessage: 'Loading' },
  clientNumber: { id: 'CommonMessages.ClientNumber', defaultMessage: 'Client number' },
  close: { id: 'CommonMessages.Close', defaultMessage: 'Close' },
  cancel: { id: 'CommonMessages.Cancel', defaultMessage: 'Cancel' },
  contractNumber: { id: 'CommonMessages.ContractNumber', defaultMessage: 'Contract number' },
  continue: { id: 'CommonMessages.Continue', defaultMessage: 'Continue' },
  submit: { id: 'CommonMessages.Submit', defaultMessage: 'Submit' },
  delete: { id: 'CommonMessages.Delete', defaultMessage: 'Delete' },
  edit: { id: 'CommonMessages.Edit', defaultMessage: 'Edit' },
  emailAddress: { id: 'CommonMessages.EmailAddress', defaultMessage: 'Email address' },
  ticketNumber: { id: 'CommonMessages.TicketNumber', defaultMessage: 'Ticket number' },
  firstName: { id: 'CommonMessages.FirstName', defaultMessage: 'First name' },
  lastName: { id: 'CommonMessages.LastName', defaultMessage: 'Last name' },
  phoneNumber: { id: 'CommonMessages.PhoneNumber', defaultMessage: 'Phone number' },
  productName: { id: 'CommonMessages.ProductName', defaultMessage: 'Product name' },
  productSku: { id: 'CommonMessages.Sku', defaultMessage: 'SKU number' },
  fieldIsRequired: { id: 'CommonMessages.FieldIsRequired', defaultMessage: 'Field is required' },
  fieldIsEmail: { id: 'CommonMessages.FieldIsEmail', defaultMessage: 'Must be a valid email address' },
  fieldIsPhoneNumber: { id: 'CommonMessages.FieldIsPhoneNumber', defaultMessage: 'Must be a valid phone number' },
  or: { id: 'CommonMessages.Or', defaultMessage: 'Or' }
});